import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import Card, {TitleCard} from '../../core/Card'
import Line from '../../core/Line'
import {
  Icon, BackIcon, FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon,
  MarkerIcon, ForwardIcon, HomeIcon, DotIcon, SortIcon,
  DateSortIcon, AlphabeticalSortIcon
} from '../../core/icons'
import { Popover, Row, Col, Button, Select, Switch as SwitchToggle, DatePicker, Radio, Input } from 'antd';
import EmptyState from '../../core/components/EmptyState'
import './FavoritePlaces.css'

const { MonthPicker, RangePicker } = DatePicker;
const RadioGroup = Radio.Group;
const Option = Select.Option;

const Favorite = ({place, onClick}) =>
  <Line className="Favorite" onClick={()=>onClick(place)}>
    <Col span={2}>
      <Icon type={place.icon_name}/>
    </Col>
    <Col span={12}>
      <Row className="title">
        {place.name}
      </Row>
      <Row className="subtitle">
        {place.street}{place.street && place.city && ", "} {place.city}
      </Row>
    </Col>
    <Col span={10}>
      <ForwardIcon/>
    </Col>
  </Line>

const All = ({onClick, places, goBack, addPlace, dispatch}) =>
  <div className="FavoritePlaces">
    <TitleCard sticky>
      <h1>Favorite Places</h1>
      <Link to="/account/favorite-places/new">
        <Button type="primary" icon="plus" onClick={addPlace}>
          New
        </Button>
      </Link>
    </TitleCard>

    <Card className="content">
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Popover
          placement="bottomRight"
          content={
            <div>
              <a onClick={()=>dispatch({type:'SORT_FAVE_PLACES', payload:'name'})}><AlphabeticalSortIcon/> Alphabetical</a>
              <hr/>
              <a onClick={()=>dispatch({type:'SORT_FAVE_PLACES', payload:'date'})}><DateSortIcon/> Most Recent</a>
            </div>
          }
          // title="Sort by:"
          trigger="click"
        >
          <Button><SortIcon/> Sort</Button>
        </Popover>
      </div>
      <div style={{display: 'flex', flexDirection: 'column'}}>

        {/*{ places.length>0 && <Button>Sort</Button> }*/}
        {places.map((place)=> <Favorite onClick={onClick} place={place}/> )}
        {places.length<1 &&
          <EmptyState
            title="No Favorite Places yet."
            buttonLink="/account/favorite-places/new"
            buttonText="Add a Favorite Place"
            buttonIcon='plus'
            icon={MarkerIcon}
          />
        }
      </div>
    </Card>


  </div>

export default All



// WEBPACK FOOTER //
// ./src/account/favorite-places/All.js